import { useState, useEffect } from "react";
import Button from "./button";
import ReactLoading from "react-loading";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { EMenuActions } from "../store";
import Img from "../Assets/bgImg.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faCommentDots,
  faReceipt,
  faLessThan,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { faHeart } from "@fortawesome/free-regular-svg-icons";
import { useLocation } from "react-router-dom";
import { createPortal } from "react-dom";

const WaiterVerificationModal = ({ wId, setWID, loading, handleVerify }) => {
  const modalRoot = document.getElementById("modal-root");
  return createPortal(
    <div className="absolute bg-dark/20 h-full w-full backdrop-blur-sm flex items-center place-content-center z-50">
      <div className="bg-white w-[80%]  p-8 rounded-lg">
        <label className="text-sm font-extrabold tracking-tighter">
          Enter your User ID
        </label>
        <input
          value={wId}
          type="password"
          name="name"
          onChange={(e) => setWID(e.target.value)}
          className={`w-[100%] mt-2 mb-2 max-sm:mb-5 border border-dark/30 rounded-md py-2 px-3 outline-none`}
          // placeholder="type here"
        />
        <Button
          title={`${loading ? "Verifying please hold on..." : "Verify"}`}
          type={"bgBtn"}
          bgColor={`bg-dark`}
          textColor={"text-white"}
          onClick={handleVerify}
        />
      </div>
    </div>,
    modalRoot
  );
};

function SideNav() {
  const dispatch = useDispatch();
  const categories = useSelector((state) => state.EMenu.categories);
  const auth_token = useSelector((state) => state.Company.auth_token);
  const C_URL = useSelector((state) => state.Company.c_url);
  const searchedValue = useSelector((state) => state.EMenu.searchedValue);
  const loading = useSelector((state) => state.EMenu.loading);
  const BranchId = useSelector((state) => state.Company.BranchId);
  const SalesPointName = useSelector((state) => state.Company.SalesPointName);
  const companyName = useSelector((state) => state.Company.company_name);
  const m_id = useSelector((state) => state.Company.m_id);
  const activeGroup = useSelector((state) => state.EMenu.activeGroup);
  const reviewLicense = useSelector((state) => state.Company.reviewLic);
  const posLicense = useSelector((state) => state.Company.POSLic);
  const bg_img = localStorage.getItem("bgimage");
  const domain = sessionStorage.getItem("domain");
  const tenant_id = sessionStorage.getItem("tenant_id");

  const waiterScreen = useLocation().pathname.split("/")[2];
  const waiter = JSON.parse(localStorage.getItem("waiterId"));
  const [wId, setWID] = useState();
  const [viewloading, setViewLoading] = useState();
  const [wIdreq, setWIdreq] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [imageUrl, setImageUrl] = useState("");
  const [linksVisible, setLinksVisible] = useState(false);

  useEffect(() => {
    const backgroundImageUrl = `https://${domain}/storage/uploads/tenant/${tenant_id}/company/${bg_img}`;
    const img = new Image();
    img.src = backgroundImageUrl;
    img.onload = () => setImageUrl(backgroundImageUrl);
    img.onerror = () => setImageUrl(Img);
  }, [domain, tenant_id, bg_img]);

  const handleClick = async ({ group_id, Group_Name }) => {
    if (group_id !== activeGroup) {
      dispatch(
        EMenuActions.setActiveGroup(group_id === activeGroup ? null : group_id)
      );
      dispatch(EMenuActions.setLoadSubCat(true));
      dispatch(EMenuActions.setLoadProducts(true));
      dispatch(EMenuActions.setViewOrder(false));
      dispatch(EMenuActions.setFavouritePage(false));
      dispatch(EMenuActions.setShowSection(true));
      if (searchedValue) {
        dispatch(EMenuActions.setSearchValue(""));
        dispatch(EMenuActions.setSearch(false));
      }
      try {
        const response = await axios.get(
          `https://${C_URL}/api/v1/ProductSubGroup/ByGroup/${group_id}/${m_id}`,
          {
            headers: { Authorization: auth_token },
          }
        );
        const c_id = response.data.data[0].categoryid;
        dispatch(EMenuActions.setSubCategory(response.data.data));
        dispatch(EMenuActions.setLoadSubCat(false));
        dispatch(EMenuActions.setMenuType(Group_Name));
        const res = await axios.get(
          `https://${C_URL}/api/v1/Product/BySubGroup/${c_id}/${m_id}`,
          {
            headers: { Authorization: auth_token },
          }
        );
        dispatch(EMenuActions.setProducts(res.data.data));
        dispatch(EMenuActions.setLoadProducts(false));
        const prodGroup = await axios.get(
          `https://${C_URL}/api/v1/Product/ByGroup/${group_id}/${m_id}`,
          {
            headers: { Authorization: auth_token },
          }
        );
        dispatch(EMenuActions.setAllProducts(prodGroup.data.data));
        dispatch(EMenuActions.setSearchResult(prodGroup.data.data));
      } catch (error) {
        console.error(error);
        toast.error(`This Category is empty ⚠️`, {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        dispatch(EMenuActions.setShowSection(false));
      }
    }
  };

  const handleImageError = (error) => {
    console.error("Error loading background image:", error);
    setImageUrl(Img);
  };

  const handleOpenFavourites = () => {
    dispatch(EMenuActions.setViewOrder(false));
    dispatch(EMenuActions.setShowSection(false));
    dispatch(EMenuActions.setFavouritePage(true));
    dispatch(EMenuActions.setLoadProducts(false));
    dispatch(EMenuActions.setActiveGroup(null));
    setLinksVisible(false);
  };

  const handleOpenReview = () => {
    dispatch(EMenuActions.setFavouritePage(false));
    dispatch(EMenuActions.setReview(true));
    // dispatch(EMenuActions.setActiveGroup(null));
    setLinksVisible(false);
  };

  // const waiterScreen = useLocation().pathname.split("/")[2];
  const handleViewOrder = () => {
    console.log(waiterScreen);
    setLinksVisible(false);

    // Check if the path is "waiterscreen"
    if (waiterScreen === "waiterscreen") {
      setIsModalVisible(true); // Show the modal
      setLinksVisible(false);
      return;
    }

    // Proceed with the original functionality

    dispatch(EMenuActions.setViewOrder(true));
    dispatch(EMenuActions.setShowSection(false));
    dispatch(EMenuActions.setLoadProducts(false));
    dispatch(EMenuActions.setFavouritePage(false));
    dispatch(EMenuActions.setActiveGroup(null));
    setLinksVisible(false);
  };

  const handleWaiterCall = () => {
    dispatch(EMenuActions.setWaiterCall(true));
    setLinksVisible(false);
  };

  const toggleLinks = () => {
    setLinksVisible(!linksVisible);
  };

  const closeLinks = () => {
    setLinksVisible(false);
  };

  const bg = {
    backgroundImage: `url(${imageUrl})`,
    backgroundColor: "rgba(0, 0, 0, 0.575)",
    backgroundBlendMode: "overlay",
    backgroundPosition: "top center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  };
  const handleVerify = async () => {
    setViewLoading(true);
    axios
      .post(
        `https://${C_URL}/api/v1/ValidateWaiterCode`,
        { waiterCode: wId },
        {
          headers: { Authorization: `${auth_token}` },
        }
      )
      .then((res) => {
        if (res.data.waiterInfo.length !== 0) {
          localStorage.setItem("waiterId", JSON.stringify(res.data.waiterInfo));
          setWIdreq(!wIdreq);
          setViewLoading(false);
          setIsModalVisible(false);
          dispatch(EMenuActions.setViewOrder(true));
        }
      })
      .catch((err) => {
        setViewLoading(false);
        toast.error("Not a valid waiter ", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  return (
    <div
      style={bg}
      className=" relative bg-image text-center  text-lg md:text-lg min-h-[100vh] max-md:min-h-screen "
      id="modal-root"
    >
      <div className="absolute w-full top-0 h-full grid items-center z-50 max-md:p-10 md:p-10 xl:p-20 max-h-[95vh] my-auto">
        <img
          src={imageUrl}
          alt="Background"
          style={{ display: "none" }}
          onError={handleImageError}
        />
        {isModalVisible && (
          <WaiterVerificationModal
            wId={wId}
            setWID={setWID}
            loading={viewloading}
            handleVerify={handleVerify}
          />
        )}

        {loading ? (
          <div className="sm:w-[70%] w-[50%] m-auto">
            <ReactLoading
              type={"spin"}
              color={"#fff"}
              height={"100%"}
              width={"100%"}
            />
          </div>
        ) : (
          <div className="h-[60vh] overflow-y-scroll no-scrollbar">
            <div
              className={`h-full flex flex-col ${
                categories.length > 6 ? "justify-start" : "justify-center"
              } items-center`}
            >
              <div className="max-md:w-[85%] w-[90%] m-auto">
                {categories.map(({ Group_Name, group_id }) => (
                  <Button
                    key={group_id}
                    type={"bgBtn"}
                    title={Group_Name}
                    bgColor={`${
                      activeGroup === group_id
                        ? "bg-primary text-white"
                        : "bg-[#fff]"
                    } hover:text-white`}
                    onClick={() => handleClick({ group_id, Group_Name })}
                  />
                ))}
              </div>
            </div>
          </div>
        )}
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 text-center">
          <span className="uppercase text-center leading-none text-white font-extrabold text-base">
            {companyName}
            <span className="text-secondary font-black text-6xl">.</span>
          </span>
        </div>
        <div className="absolute bottom-4 w-[100%]">
          {" "}
          <div className="">
            <span className="rounded-md p-0.5 px-3 m-auto text-center uppercase text-base font-bold text-white">
              {BranchId} - {SalesPointName}
            </span>
          </div>
          {/* Adjusted bottom positioning */}
          <div className="flex w-[50%] max-sm:w-[60%] m-auto items-center text-center">
            {/* <div className="border-t border-white w-[20%]"></div> */}
            <div className="w-[100%] max-sm:w-[100%]">
              <p className="capitalize text-xs text-white font-bold">
                E-Menu by CRANESOFT
              </p>
            </div>
          </div>
        </div>
        <div className="bg-primaryLight w-[90%]">
          <div
            className="absolute bg-white flex cursor-pointer items-center justify-center hover:bg-secondary text-secondary/90 hover:text-white w-8 h-8 top-1 rounded-lg left-1 hover:scale-110 ml-3 mt-2"
            onClick={toggleLinks}
          >
            <FontAwesomeIcon icon={faBars} size="sm" />
          </div>
          <div
            className={`links absolute top-0 ${
              linksVisible ? "left-[0rem]" : "-left-[50rem] "
            } bg-[#f5f5f5] p-10 w-[100%] min-h-[100vh] ease-linear duration-500`}
          >
            <div className="flex justify-end ml-10 cursor-pointer">
              <FontAwesomeIcon icon={faLessThan} onClick={closeLinks} />
            </div>
            <div className="grid gap-4 mt-">
              <div
                className="flex items-center gap-3 cursor-pointer hover:text-secondary"
                onClick={handleOpenFavourites}
              >
                <div className="text-secondary/70 flex cursor-pointer items-center justify-center w-8 h-8 rounded-full hover:scale-110">
                  <FontAwesomeIcon icon={faHeart} size="sm" />
                </div>
                <p>Favourite</p>
              </div>
              {Number(posLicense) === 2 && (
                <div
                  className="flex items-center gap-3 cursor-pointer hover:text-secondary"
                  onClick={handleViewOrder}
                >
                  <div className="text-secondary/70 flex cursor-pointer items-center justify-center w-8 h-8 rounded-full hover:scale-110">
                    <FontAwesomeIcon icon={faReceipt} size="sm" />
                  </div>
                  <p>View Orders </p>
                </div>
              )}
              {Number(reviewLicense) === 8 && (
                <div
                  className="flex items-center gap-3 cursor-pointer hover:text-secondary"
                  onClick={handleOpenReview}
                >
                  <div className="text-secondary/70 flex cursor-pointer items-center justify-center w-8 h-8 rounded-full hover:scale-110">
                    <FontAwesomeIcon icon={faCommentDots} size="sm" />
                  </div>
                  <p>Review</p>
                </div>
              )}
              {waiterScreen !== "waiterscreen" && (
                <div
                  className="flex items-center gap-3 cursor-pointer hover:text-secondary"
                  onClick={handleWaiterCall}
                >
                  <div className="text-secondary/70 flex cursor-pointer items-center justify-center w-8 h-8 rounded-full hover:scale-110">
                    <FontAwesomeIcon icon={faPhone} size="sm" />
                  </div>
                  <p>Call a waiter</p>
                </div>
              )}
            </div>
            <div className="absolute bottom-3 w-[80%] text-center">
              <p className="uppercase font-extrabold tracking-tight text-3xl leading-[1%]">
                {companyName}
                <span className="text-secondary font-black text-6xl">.</span>
              </p>
              <div className="flex w-[50%] max-sm:w-[60%] m-auto items-center text-center">
                <div className="border-t border-secondary w-[20%]"></div>
                <div className="w-[100%] max-sm:w-[100%]">
                  <p className="capitalize text-sm text-secondary font-bold">
                    E-Menu by CRANESOFT
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SideNav;
